export default __webpack_public_path__ + "static/media/003-coffee.9f1292d5.svg";